import { Box } from 'approot/shared/design-system/box/box.style';
import { BoldStyled } from 'approot/shared/styles/typography.style';
import * as Styled from './assignments-feedback.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import FeedbackSurveyModal from 'approot/shared/feedback-survey/feedback-survey-modal';
import { FEEDBACK_ASSIGNMENTS, FeedbackFeature } from 'global/constants';

type Props = {
  titleText?: string;
  buttonText: string;
  isButton?: boolean;
  gap?: number;
  feature?: FeedbackFeature;
};

const AssignmentsFeedback = ({
  titleText,
  buttonText,
  isButton,
  gap = 4,
  feature = FEEDBACK_ASSIGNMENTS,
}: Props) => {
  const { openModal, isVisible, closeModal } = useSimpleModalState();
  const handleShowSurvey = () => {
    openModal();
  };

  return (
    <>
      <FeedbackSurveyModal
        isVisible={isVisible}
        closeModal={closeModal}
        feature={feature}
      />
      <Box $flexDirection="row" $gap={gap} $justifyContent="center">
        <BoldStyled marginBottom={0}>{titleText}</BoldStyled>
        {isButton ? (
          <SecondaryButton onClick={handleShowSurvey}>
            {buttonText}
          </SecondaryButton>
        ) : (
          <Styled.FeedbackButton
            type="button"
            $overrideFont
            onClick={handleShowSurvey}
          >
            {buttonText}
          </Styled.FeedbackButton>
        )}
      </Box>
    </>
  );
};

export default AssignmentsFeedback;
